export default __webpack_public_path__ + "static/media/customer1.b47b58fc.svg";